import { useSelector } from 'react-redux';
import BaseTable from '../../components/BaseTable';
import { fetchPatientProfilesList } from '../../api/careRecords';
import { CARE_TABLE_KIND, useTableColumns } from '../../hooks/columns';
import { useCareList } from '../../hooks/useCareList';

export default function Patients() {
  const token = useSelector((state) => state.auth.token);
  const columns = useTableColumns(CARE_TABLE_KIND.patients);
  const { data, loading, error } = useCareList(fetchPatientProfilesList, token);

  return (
    <div className="care-page">
      <BaseTable
        columns={columns}
        dataSource={data}
        loading={loading}
        error={error}
        searchKeys={[
          'id',
          'primary_condition',
          'phone',
          'district',
          'state',
          'care_mode',
          'medical_conditions',
          'allergies',
          'user.email',
          'user.username',
          'user.name',
          'user.id',
          'user_email',
          'user_name',
          'user_id'
        ]}
        searchPlaceholder="Search condition, location, phone, user…"
        emptyText="No patient profiles found."
      />
    </div>
  );
}
